export const scrollImage = (sidebar, item, image) => {
	if (window.innerWidth >= 956 && item.classList.contains(`media`) && image)
	{
		const imagePath = image.offsetHeight - image.parentElement.offsetHeight;
		const pictureVerticalOffset = parseInt(window.getComputedStyle(item).marginTop) + parseInt(window.getComputedStyle(item).marginBottom);
		const startPicturePos = sidebar.offsetTop;
		const endPicturePos = sidebar.offsetTop + sidebar.offsetHeight - item.offsetHeight - pictureVerticalOffset;
		const allPath = endPicturePos - startPicturePos;
		const currentPicturePos = item.offsetTop;
		const currentPath = currentPicturePos - startPicturePos;
		
		if ( currentPath > 0 )
		{
			let shiftPercentage = currentPath / allPath * 100;
			
			if ( shiftPercentage > 100 )
			{
				shiftPercentage = 100;
			}
			
			if ( shiftPercentage < 0 )
			{
				shiftPercentage = 0;
			}
			
			const shift = imagePath / -100 * shiftPercentage;
			
			image.style.transform = `translateY(${shift}px)`;
		}
	}
};
